export const SHOW_CHANGE_PASS_MODAL = 'boilerplate/ChangePassword/ShowModal';
export const CLOSE_CHANGE_PASS_MODAL = 'boilerplate/ChangePassword/CloseModal';
export const LOADER_STATUS = 'boilerplate/ChangePassword/LOADER_STATUS';
export const RESPONSE_MESSAGE = 'boilerplate/ChangePassword/RESPONSE_MESSAGE';